import { FormaPagamentoItem, ConfiguracaoFormasDePagamentoModel } from "../models/configuracaoFormasDePagamentoModel"

export enum ConfiguracaoFormasDePagamentoActionsTypes {
    CARREGAR = "CARREGAR",
    TOGGLE_ASSOCIADO = "TOGGLE_ASSOCIADO",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
}

export type ConfiguracaoFormasDePagamentoActionModel =
    | {
          type: ConfiguracaoFormasDePagamentoActionsTypes.CARREGAR
          payload: ConfiguracaoFormasDePagamentoModel
      }
    | {
          type: ConfiguracaoFormasDePagamentoActionsTypes.TOGGLE_ASSOCIADO
          payload: { index: number }
      }
    | {
          type: ConfiguracaoFormasDePagamentoActionsTypes.ATUALIZAR_CAMPO
          payload: {
              index: number
              campo: keyof FormaPagamentoItem
              valor: string | number | boolean | null
          }
      }
